<template>
  <b-form-group id="new-password-input-group" :class="'form-group-password-comp ' + form_group_class + ' row w-100 mx-0'"
    :label="label ? label : $t('password') + '*'" label-for="password" :password="password" :label-class="form_label_class"
    >
    <p :class="error_message_class" v-if="invalid_password">
      {{ $t('invalid_password') }}
    </p>
    <p :class="error_message_class" v-if="invalid_correct_password">
      {{ $t('incorrect_password') }}
    </p>

    <b-row class="w-100 mx-0 px-0">
      <b-col class="pl-0">
        <b-input-group class="input-group-password input-group-validate-password">
          <b-form-input class="form-control-validate-password" 
          :class="input_class" id="password" v-model="_password"
            :type="show_password ? 'text' : 'password'" :placeholder="$t('placeholder_password')"
            @focus="focusPasswordField" @blur="blurPasswordField" required></b-form-input>
          <b-input-group-append>
            <b-button @click="show_password = !show_password"><font-awesome-icon icon="fa-solid fa-eye"
                v-if="!show_password" />
              <font-awesome-icon icon="fa-solid fa-eye-slash" v-else /></b-button>
          </b-input-group-append>
        </b-input-group>
        <ul :class="validation_ul_class">
          <li v-bind:class="{ is_valid: contains_eight_characters }">
            {{ $t('validate_password_8_char') }}
          </li>
          <li v-bind:class="{ is_valid: contains_number }">
            {{ $t('validate_password_num') }} 
          </li>
          <li v-bind:class="{ is_valid: contains_uppercase }">
            {{ $t('validate_password_uppercase') }}
          </li>
          <li v-bind:class="{ is_valid: contains_special_character }">
            {{ $t('validate_password_special') }} 
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-form-group>
</template>
<script>
import $ from 'jquery'
export default {
  name: "PasswordValidation",
  props: [
    "label",
    "password",
    "input_class",
    "invalid_password",
    "invalid_correct_password",
    "validation_ul_class",
    "form_group_class",
    "form_label_class",
    "error_message_class"
  ],
  data() {
    return {
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password: false,
      show_password: false
    };
  },
  mounted() { },
  computed: {
    _password: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit("update:password", value);
      },
    },
  },
  watch: {
    _password(newval, oldval) {
      // console.log(newval, oldval)
      this.password_length = this.password.length;
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.password_length >= 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);
      this.contains_special_character = format.test(this.password);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
  },
  methods: {
    focusPasswordField() {
      $('.input-group-validate-password').addClass('focus')
    },
    blurPasswordField() {
      $('.input-group-validate-password').removeClass('focus')
    }
  }

};
</script>



// WEBPACK FOOTER //
// src/components/Inputs/PasswordValidation.vue